import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import CatingServices from '../../../services/CastingService';
import Swal from 'sweetalert2';

const AddCastingModal = ({ show, handleClose, test, item, RequestNo, storeName, data, RequestType, loginUser }) => {
  const [castingQty, setCastingQty] = useState(0);
  const [castingQtyError, setCastingQtyError] = useState("");

  console.log("rrere", item)

  // Reset Casting Qty whenever modal is closed

  const handleModalClose = () => {
    setCastingQty(0);
    setCastingQtyError("");
    handleClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const qty = Number(castingQty);

    /* ===============================
       🔒 HARD VALIDATIONS
    =============================== */

    if (!RequestType) {
      Swal.fire("Error", "Request Type missing", "error");
      return;
    }

    if (!item?.inventoryId) {
      Swal.fire(
        "Error",
        "Inventory ID not found. Please reload the page.",
        "error"
      );
      return;
    }

    if (!item?.masterItem) {
      Swal.fire(
        "Error",
        "Master Item ID not found. Please reload the page.",
        "error"
      );
      return;
    }
    if (!qty || isNaN(qty)) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Quantity",
        text: "Invalid Quantity",
      });
      return;
    }

    // Temporarily allow only negative quantity for MIV
    if (RequestType === "MIV" && qty >= 0) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Quantity",
        text: "For MIV, only negative quantity is currently allowed.",
      });
      return;
    }

    /* ===============================
       🚀 API CALL
    =============================== */

    try {
      await CatingServices.AddCasting({
        RequestNo,
        RequestType,

        // 🔑 REQUIRED IDs
        inventory: item.inventoryId,
        masterItem: item.masterItem,

        // 📦 INFO
        partNo: item.partNo,
        description: item.description,
        unitName: item.unitName,
        storeName,
        user: loginUser,

        // 📊 QTY
        qtyRequired: item.qtyRequired,
        qtyRecived: item.qtyRecived,
        approveQty: item.approveQty,
        castingQty: qty,
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Casting Request executed successfully!",
        timer: 2000,
        showConfirmButton: false,
      });

      setCastingQty(0);

      setTimeout(() => {
        test((prev) => prev + 1);
        handleModalClose();
      }, 2000);

    } catch (error) {
      console.error("Casting Error:", error);

      Swal.fire({
        icon: "error",
        title: "Failed",
        text:
          error?.response?.data?.message ||
          "Failed to create casting record",
      });
    }
  };


  return (
    <Modal className="fade" show={show} onHide={handleModalClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title><i className="fas fa-edit"></i>Create Casting {RequestType} Record</Modal.Title>
          <Button variant="" className="btn-close" onClick={handleModalClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>

            {/* MIV Casting Quantity Note */}
            {RequestType === "MIV" && (
              <div className="alert alert-info mb-3" role="alert">
                <strong>Note:</strong>
                <div className="mt-1">
                  • <strong>Positive Qty (+):</strong> Issued/MIV quantity will increase and inventory stock will decrease.
                </div>
                <div>
                  • <strong>Negative Qty (-):</strong> Issued/MIV quantity will decrease and inventory stock will increase.
                </div>
              </div>
            )}

            <Row>
              <Col md="6">
                <label>{RequestType === 'MRV' ? 'MRV No' : 'MIV No'}</label>
                <input type="text" className="form-control form-control-sm" value={RequestNo || 'N/A'} readOnly />
              </Col>
              <Col md="6">
                <label>Part No.</label>
                <input type="text" className="form-control form-control-sm" value={item?.partNo || 'N/A'} readOnly />
              </Col>
              <Col md="6">
                <label>Unit</label>
                <input type='text' className="form-control form-control-sm" value={item?.unitName} readOnly />
              </Col>
              <Col md="6">
                <label>Required Qty</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={RequestType === "MIV" ? "N/A" : (item?.qtyRequired ?? "N/A")}
                  readOnly
                />
              </Col>
              <Col md="6">
                <label>Approved Qty</label>
                <input type='text' className="form-control form-control-sm" value={item?.approveQty} readOnly />
              </Col>
              <Col md="6">
                <label>Received Qty</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={RequestType === "MIV" ? "N/A" : (item?.qtyRecived ?? "N/A")}
                  readOnly
                />
              </Col>
              <Col md="6">
                <label>Casting Qty</label>
                <input
                  type="number"
                  className={`form-control form-control-sm ${castingQtyError ? "is-invalid" : ""
                    }`}
                  value={castingQty}

                  // Remove default 0 when user clicks/focuses the field
                  onFocus={() => {
                    if (Number(castingQty) === 0) {
                      setCastingQty("");
                      setCastingQtyError("");
                    }
                  }}

                  // Prevent mouse wheel from increasing/decreasing quantity
                  onWheel={(e) => {
                    e.currentTarget.blur();
                  }}

                  onChange={(e) => {
                    const value = e.target.value;
                    setCastingQty(value);

                    if (
                      RequestType === "MIV" &&
                      value !== "" &&
                      Number(value) >= 0
                    ) {
                      setCastingQtyError(
                        "Only negative quantity is allowed."
                      );
                    } else {
                      setCastingQtyError("");
                    }
                  }}
                />
              </Col>

              <Col md="6" className="d-flex align-items-end">
                {castingQtyError && (
                  <div className="text-danger mb-2">
                    <i className="fas fa-exclamation-circle me-1"></i>
                    <strong>{castingQtyError}</strong>
                  </div>
                )}
              </Col>
              <Col md="12">
                <label>Description</label>
                <textarea rows="1" className="form-control form-control-sm" value={item?.description} readOnly />
              </Col>

            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={handleModalClose}>
            Close
          </Button>

          {!castingQtyError && (
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          )}
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default AddCastingModal;
